export const ANALYTICS_SCHEDULAR_BOOKING_EVENTS = {
  BOOKING_BROWSER_DETAILS: 'Booking Browser Details',
  BOOKING_UNSUPPORTED_BROWSER_DETECTED: 'Booking Unsupported Browser Detected',
} as const;
